import React, { createContext, useContext, useState, useCallback } from 'react';

interface BottomNavContextValue {
  isVisible: boolean;
  setVisible: (visible: boolean) => void;
}

const BottomNavContext = createContext<BottomNavContextValue | null>(null);

export const BottomNavProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);

  const setVisible = useCallback((visible: boolean) => {
    setIsVisible(visible);
  }, []);

  return (
    <BottomNavContext.Provider value={{ isVisible, setVisible }}>
      {children}
    </BottomNavContext.Provider>
  );
};

export const useBottomNav = () => {
  const context = useContext(BottomNavContext);
  if (!context) {
    throw new Error('useBottomNav must be used within a BottomNavProvider');
  }
  return context;
};

// Safe hook that doesn't throw if used outside provider (for Sheet component)
export const useBottomNavSafe = () => {
  return useContext(BottomNavContext);
};
